<script>
  import { _ } from "@services/i18n";
  import { supportsEnhancedExperience } from "@utils/support";

  export let transcript;
</script>

<style>
  :global(html:not(.enhanced)) .transcript {
    height: auto;
    position: absolute;
    top: calc(100% + 80px);
    width: 100%;
  }

  .hidden {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    position: absolute;
    width: 1px;
  }
</style>

{#if transcript}
  <div class:hidden={supportsEnhancedExperience} class="transcript">
    <h4>{$_("components.transcript.title", { default: "Transcript" })}</h4>
    <p>{transcript}</p>
  </div>
{/if}
